<app-arcgis-map 
    [activeLayerSelector]="1 === 1"
    [layerList]="layerListSubject"></app-arcgis-map>

<div *ngIf="ticket.externalFeatures.length > 0">
    <h1>Attribútumok kitöltése</h1>
    <div *ngFor="let item of ticketAttributes; let i = index;">
        <app-fill-ticket-attribute *ngIf="i === currentIndex" [ticketAttribute]="item" [filledSubject]="attributeFilledSubject"></app-fill-ticket-attribute>
    </div>
</div>